export const createAgentDefaultValues = {
  name: '',
  ticker: '',
  description: '',
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  image: null as File | null,
  twitter: '',
  telegram: '',
  youtube: '',
  website: '',
};
export type CreateAgentFormValues = typeof createAgentDefaultValues;
